
export const text = `The third item to be aware of is the actors in the video. If any of their voices have been replaced, first try adjusting your audio. If all of the voices have been swapped, this is nothing to be concerned about. Just keep watching the video until the voices are correctly realigned. Your quality assurance and feedback are appreciated. 



`